import React from 'react';

export const GooglePresentationIcon = () => (
	<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
		<mask id="mask0_271_181646" maskUnits="userSpaceOnUse" x="7" y="4" width="15" height="20">
			<path
				d="M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z"
				fill="white"
			/>
		</mask>
		<g mask="url(#mask0_271_181646)">
			<path
				d="M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L18.7188 7.18182L16.375 4Z"
				fill="#F4B400"
			/>
		</g>
		<mask id="mask1_271_181646" maskUnits="userSpaceOnUse" x="7" y="4" width="15" height="20">
			<path
				d="M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z"
				fill="white"
			/>
		</mask>
		<g mask="url(#mask1_271_181646)">
			<path
				d="M17.5469 13.0908H11.4531C11.0664 13.0908 10.75 13.3976 10.75 13.7726V19.6817C10.75 20.0567 11.0664 20.3635 11.4531 20.3635H17.5469C17.9336 20.3635 18.25 20.0567 18.25 19.6817V13.7726C18.25 13.3976 17.9336 13.0908 17.5469 13.0908ZM17.3125 18.3181H11.6875V15.1363H17.3125V18.3181Z"
				fill="#F1F1F1"
			/>
		</g>
		<mask id="mask2_271_181646" maskUnits="userSpaceOnUse" x="7" y="4" width="15" height="20">
			<path
				d="M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z"
				fill="white"
			/>
		</mask>
		<g mask="url(#mask2_271_181646)">
			<path
				d="M16.7866 9.05518L22.0003 14.1097V9.45404L16.7866 9.05518Z"
				fill="url(#paint0_linear_271_181646)"
			/>
		</g>
		<mask id="mask3_271_181646" maskUnits="userSpaceOnUse" x="7" y="4" width="15" height="20">
			<path
				d="M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z"
				fill="white"
			/>
		</mask>
		<g mask="url(#mask3_271_181646)">
			<path
				d="M16.375 4V8.09091C16.375 8.84432 17.0043 9.45454 17.7813 9.45454H22L16.375 4Z"
				fill="#FADA80"
			/>
		</g>
		<mask id="mask4_271_181646" maskUnits="userSpaceOnUse" x="7" y="4" width="15" height="20">
			<path
				d="M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z"
				fill="white"
			/>
		</mask>
		<g mask="url(#mask4_271_181646)">
			<path d="M16.375 4V4.11364L21.8828 9.45454H22L16.375 4Z" fill="white" fillOpacity="0.1" />
		</g>
		<mask id="mask5_271_181646" maskUnits="userSpaceOnUse" x="7" y="4" width="15" height="20">
			<path
				d="M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z"
				fill="white"
			/>
		</mask>
		<g mask="url(#mask5_271_181646)">
			<path
				d="M8.40625 4C7.63281 4 7 4.61364 7 5.36364V5.47727C7 4.72727 7.63281 4.11364 8.40625 4.11364H16.375V4H8.40625Z"
				fill="white"
				fillOpacity="0.2"
			/>
		</g>
		<mask id="mask6_271_181646" maskUnits="userSpaceOnUse" x="7" y="4" width="15" height="20">
			<path
				d="M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z"
				fill="white"
			/>
		</mask>
		<g mask="url(#mask6_271_181646)">
			<path
				d="M20.5937 23.8866H8.40625C7.63281 23.8866 7 23.2729 7 22.5229V22.6366C7 23.3866 7.63281 24.0002 8.40625 24.0002H20.5937C21.3672 24.0002 22 23.3866 22 22.6366V22.5229C22 23.2729 21.3672 23.8866 20.5937 23.8866Z"
				fill="#BF360C"
				fillOpacity="0.2"
			/>
		</g>
		<mask id="mask7_271_181646" maskUnits="userSpaceOnUse" x="7" y="4" width="15" height="20">
			<path
				d="M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z"
				fill="white"
			/>
		</mask>
		<g mask="url(#mask7_271_181646)">
			<path
				d="M17.7812 9.45494C17.0043 9.45494 16.375 8.84472 16.375 8.09131V8.20495C16.375 8.95835 17.0043 9.56858 17.7812 9.56858H22V9.45494H17.7812Z"
				fill="#BF360C"
				fillOpacity="0.1"
			/>
		</g>
		<path
			d="M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z"
			fill="url(#paint1_radial_271_181646)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_271_181646"
				x1="277.498"
				y1="52.454"
				x2="277.498"
				y2="514.58"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#BF360C" stopOpacity="0.2" />
				<stop offset="1" stopColor="#BF360C" stopOpacity="0.02" />
			</linearGradient>
			<radialGradient
				id="paint1_radial_271_181646"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(54.5207 43.5288) scale(2418.73 2345.43)"
			>
				<stop stopColor="white" stopOpacity="0.1" />
				<stop offset="1" stopColor="white" stopOpacity="0" />
			</radialGradient>
		</defs>
	</svg>
);
